export const SIDEBAR_COLLAPSED_STORAGE_KEY = 'charitystack-dashboard-sidebar-collapsed';
export const SIDEBAR_WIDTH_STORAGE_KEY = 'charitystack-dashboard-sidebar-width';
export const SIDEBAR_STATE_EVENT = 'charitystack-dashboard-sidebar-state-change';
// These bounds are the existing resizable sidebar's pixel domain, shared with startup.
export const SIDEBAR_COLLAPSED_WIDTH = 80;
export const SIDEBAR_DEFAULT_WIDTH = 224;
export const SIDEBAR_EXPANDED_MIN_WIDTH = 200;
export const SIDEBAR_MAX_WIDTH = 320;
export const clampExpandedWidth = (value) =>
  Math.min(SIDEBAR_MAX_WIDTH, Math.max(SIDEBAR_EXPANDED_MIN_WIDTH, value));

export function getStoredSidebarWidth() {
  try {
    const stored = Number(window.localStorage.getItem(SIDEBAR_WIDTH_STORAGE_KEY));
    return Number.isFinite(stored) && stored >= SIDEBAR_EXPANDED_MIN_WIDTH
      ? Math.min(SIDEBAR_MAX_WIDTH, stored)
      : SIDEBAR_DEFAULT_WIDTH;
  } catch {
    return SIDEBAR_DEFAULT_WIDTH;
  }
}

export function getInitialSidebarCollapsed() {
  try {
    return window.localStorage.getItem(SIDEBAR_COLLAPSED_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
}

export function getInitialSidebarWidth() {
  return getInitialSidebarCollapsed() ? SIDEBAR_COLLAPSED_WIDTH : getStoredSidebarWidth();
}
